export type ListBoxOption = {
  value: string
  text: string
}

export default function ListBox({
  label,
  options,
  selectedOption,
  setSelectedOption,
}: {
  label: string
  options: ListBoxOption[]
  selectedOption: ListBoxOption
  setSelectedOption: (option: ListBoxOption) => void
}) {
  return (
    <div className='space-y-1'>
      <label className='block text-[10px] font-semibold uppercase tracking-[0.06em] text-[var(--sc-muted)]'>
        {label}
      </label>
      <select
        value={selectedOption.value}
        onChange={(e) => {
          const found = options.find((o: ListBoxOption) => o.value === e.target.value)
          if (found) setSelectedOption(found)
        }}
        className='w-full rounded-lg border border-[var(--sc-border)] bg-[var(--sc-surface)] px-3 py-2 text-sm text-[var(--sc-text)] focus:outline-none focus:ring-1 focus:ring-[var(--sc-amber)]'
      >
        {options.map((option: ListBoxOption) => (
          <option key={option.value} value={option.value}>{option.text}</option>
        ))}
      </select>
    </div>
  )
}

